// extracted by mini-css-extract-plugin
export default {"navTabs":"NavTabs_navTabs__2tPt4"};